module.exports = __webpack_public_path__ + "static/altamed-e1e141b02a8112f8b63dea35c9f6cb52.jpg";